module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-down-4704b1976a3ea6f95ee09d3b378d9a48.png";